import React from 'react';

export default function TradingAgreement() {
    return (
        <div>
            <div className={'page-header'}>
                <div className={'content'}>
                    <h1>Trading Agreement</h1>
                </div>
            </div>
            <div className={'content'}>
                <article className="legalContent">
                    <p>This page contains the latest Costcutter Supermarkets Group Ltd Trading Terms</p>
                    <ul>
                        <li>If you are a retailer on a trading agreement click <a
                            href={window.CONFIG['activoc-react-web.retail-trading-agreement-url']}
                            title='retail trading agreement' target="_blank"
                            rel="noopener noreferrer">here</a> for your T&Cs.
                        </li>
                        <li>If you are a supply only retailer click <a
                            href={window.CONFIG['activoc-react-web.supply-only-trading-agreement-url']}
                            title='supply only trading agreement' target="_blank"
                            rel="noopener noreferrer">here</a> for your T&Cs.
                        </li>
                    </ul>
                    <p>If you are unsure which contract is applicable to your account please contact customer services
                        and they will be able to advise.</p>
                    <p>For the avoidance of doubt your commercial terms sheet (CTS) or letter of variation will not be
                        varied by any changes to the terms and conditions stipulated in these links.</p>
                    <p>You will be notified separately in the event that your CTS or letter of variation is updated.</p>
                </article>
            </div>
        </div>
    )
}



